import {
  DATA_ATTR_PREFIX,
  ADD_BUTTON_TEXT_UNAVAILABLE_STRING
} from './const'
import {
  updateCurrentOptions,
} from './options'
import {
  initEventListeners
} from './events'
import {
  updateCurrentVariant
  ,
  getVariantData
} from './variants'
import {
  updateDomAddButton
} from './dom'
import {
  compareInputValues
} from './helpers'
import {
  initVariantFromUrl,
  preselectVariantQuantityAvailable
} from './helpers'


const el: HTMLElement | null = document.querySelector(`[${DATA_ATTR_PREFIX}]`);

if (!('prodify' in window) && el) {
  const pickerTypes: Record<string, 'radio' | 'select'> = {}
  const optionContainers = Array.from(el.querySelectorAll('[data-prodify-option-container]'))

  for (let i = 0; i < optionContainers.length; i++) {
    const select = optionContainers[i].querySelector('select')
    pickerTypes[`option${i + 1}`] = select ? 'select' : 'radio'
  }

  (window as Window).prodify = {
    el,
    pickerTypes,
  }

  getVariantData()

  initVariantFromUrl()
  updateCurrentOptions()
  updateCurrentVariant()
  preselectVariantQuantityAvailable()
  compareInputValues()

  if (!(window as Window).prodify.currentVariant) {
    updateDomAddButton(true, ADD_BUTTON_TEXT_UNAVAILABLE_STRING, true, false)
  }

  initEventListeners()
}
